import React from 'react';
import {
	Breakpoints,
	Container,
	ContainerPadding,
	Layout,
	Text,
	TokenTextAppearance,
} from '@volkswagen-onehub/components-core';
import { ServiceLayer } from '../services-layer-types';
import { Vehicle } from '@esportal/portal-service';
import { getMonthsBetweenDates, manufacturerWarrantyEndDate } from '../../../../helpers/servicesHelper';
import { ServiceStatusIndicator } from '../../components/service-status-indicator';
import styled from 'styled-components';
import ProgressChart from '../../components/ProgressChart';

const WarrantyContainer = styled.div`
	border-radius: 8px;
	border: 1px solid var(--Secondary-grey200, #c2cacf);
`;

const WarrantyContainerDetail = styled.div`
	padding: var(--size-dynamic0050);
`;

const BottomPaddingContainer = styled(Container)`
	padding-bottom: var(--size-dynamic0100);

	> div {
		display: block; 

	@media (min-width: 960px) {
		padding-bottom: 0;

	}
`;

export const garantiaVolkswagenLayer = (vehicle: Vehicle): ServiceLayer => {
	let remainingMonths = 0;
	const manufacturerWarrantyDate = manufacturerWarrantyEndDate(
		vehicle.licenseDate!,
		vehicle.warranty.anyosCoberturaGarantia!,
	);

	if (vehicle.warranty.warrantyEndingDate) {
		const now = Date.now();
		const warrantyEnd = new Date(vehicle.warranty.warrantyEndingDate).getTime();
		remainingMonths = getMonthsBetweenDates(now, warrantyEnd);

		console.log(getMonthsBetweenDates(now, warrantyEnd)); // ¿Da 34?
		console.log(Math.ceil(getMonthsBetweenDates(now, warrantyEnd))); // ¿Da 34 o 35
	}

	return {
		header: 'Coberturas',
		title: 'Garantía de tu Volkswagen',
		subtitle: (
			<Text appearance={TokenTextAppearance.copy200}>
				{`Buenas noticias: tu ${vehicle.comercialDenomination} aún tiene ${remainingMonths} ${
					remainingMonths === 1 ? 'mes' : 'meses'
				} de garantía. Así, solo tendrás que preocuparte de disfrutarlo al máximo.`}
			</Text>
		),
		description: (
			<>
				<Container padding={{ bottom: ContainerPadding.dynamic0130 }}>
					<Text appearance={TokenTextAppearance.headline200} bold>
						Tiempo disponible de garantía:
					</Text>
				</Container>
				<Layout
					data-testid="services-layout"
					appearance={{
						[Breakpoints.default]: [
							{ name: 'a', columns: 24 },
							{ name: '.', columns: 24 },
							{ name: 'b', columns: 24 },
						],
						[Breakpoints.b960]: [
							{ name: 'a', columns: 11 },
							{ name: '.', columns: 2 },
							{ name: 'b', columns: 11 },
						],
					}}
				>
					<BottomPaddingContainer data-testid="bottompadding">
						<WarrantyContainer data-testid="warranty-container">
							<WarrantyContainerDetail>
								<Container padding={{ bottom: ContainerPadding.static300 }}>
									<Text appearance={TokenTextAppearance.headline200} bold>
										Garantía del vehículo nuevo
									</Text>
								</Container>
								{manufacturerWarrantyDate !== null && (
									<ServiceStatusIndicator
										date={manufacturerWarrantyDate}
										fullDescription={true}
										diffDaysCheck={90}
									/>
								)}
								<ProgressChart vehicle={vehicle} type="manufacturer" />
							</WarrantyContainerDetail>
						</WarrantyContainer>
					</BottomPaddingContainer>

					{vehicle.warranty.flagHiredWarrantyExtension && (
						<WarrantyContainer>
							<WarrantyContainerDetail>
								<Container padding={{ bottom: ContainerPadding.static300 }}>
									<Text appearance={TokenTextAppearance.headline200} bold>
										Extensión de garantía
									</Text>
								</Container>
								<Text appearance={TokenTextAppearance.copy200}>
									Aplica una vez expira la garantía del vehículo nuevo
								</Text>
								<ServiceStatusIndicator
									date={vehicle.warranty.warrantyEndingDate!}
									fullDescription={true}
									diffDaysCheck={90}
									warrantyCoverageKms={vehicle.warranty.warrantyCoverageKms ?? undefined}
								/>
								<ProgressChart vehicle={vehicle} type="extended" />
							</WarrantyContainerDetail>
						</WarrantyContainer>
					)}
				</Layout>
			</>
		),
		imageFooter:
			'https://assets.volkswagen.com/is/image/volkswagenag/layer-garantia?Zml0PWNyb3AlMkMxJndpZD0xOTIwJmhlaT01NDAmZm10PWpwZWcmcWx0PTc5JmJmYz1vZmYmMmFiZg==',
	};
};
